import {load} from '@shopify/theme-sections'
import '../../styles/sections/section-contact-us.scss'
import '../../styles/sections/template-flexible.scss'
import '../../styles/templates/page.scss'

import '../sections/index-accordion'
import '../sections/index-articles'
import '../sections/index-articles-row'
import '../sections/index-brands-showcase'
import '../sections/index-buyers-guide'
import '../sections/index-content-grid'
import '../sections/index-content-image-grid'
import '../sections/index-counter'
import '../sections/index-download-tabs'
import '../sections/index-feature-contact'
import '../sections/index-featured-products'
import '../sections/index-finance-block'
import '../sections/index-hero-category'
import '../sections/index-hero-cta'
import '../sections/index-hero-image'
import '../sections/index-icons-links'
import '../sections/index-image-content'
import '../sections/section-how-it-works'
import '../sections/index-hero-slider'
import '../sections/section-multi-column-modals'
import '../sections/section-accordion-right'
import '../sections/section-steps'
import '../sections/section-enquire-form-v2'
import '../sections/section-accordion-two-columns-v2'
import '../sections/section-testimonial-v2'
import '../sections/section-icon-carousel'
import '../sections/section-icon-3-cols'
import '../sections/section-three-card-blogs'
import '../sections/section-2-price-card'
import '../sections/section-two-col-complex'
import '../sections/custom-images'
import '../sections/banner-with-text'
import '../sections/tabs-content' // Further down this is "content-with-tabs"
import '../sections/section-custom-collection-list'
import '../sections/section-custom-locations'
import '../sections/section-headshots'
import '../sections/section-border-content'
import '../sections/contact-us-grid'
import '../sections/section-brands'
import '../sections/section-tabbed-calculator'
import '../sections/section-leadership-cards'
import '../sections/section-flexible-table-content'
import '../sections/section-flexible-accordion-content'
import '../sections/section-flexible-video'
import '../sections/section-highlights'

// CSS ONLY, NO JS
import '../sections/section-tax-disclaimer'
import '../sections/index-feature-block'
import '../sections/index-chart'
import '../sections/index-image-content-row'
import '../sections/index-key-features'
import '../sections/index-product-carousel'
import '../sections/index-reviews'
import '../sections/index-feature-cta'
import '../sections/section-compare-price-list'
import '../sections/section-cta-content-card'
import '../sections/section-dual-content-cards'
import '../sections/section-list-group-content'
import '../sections/section-center-text'
import '../sections/section-six-tiles'
import '../sections/section-img-text'
import '../sections/section-center-text-AS.js'
import '../sections/section-three-column'
import '../sections/section-calculator-v2'
import '../sections/section-review-star'
import '../sections/section-four-grids'
import '../sections/section-4-col-tiles'
import '../sections/section-heading-text'
import '../sections/section-compare-table'
import '../sections/section-table-with-text'
import '../sections/section-multi-column-content'
import '../sections/section-internal-navigation-grid'
import '../sections/section-business-location'
import '../sections/section-icon-6-col'
import '../sections/section-border-content-module'
import '../sections/section-quote-card'
import '../sections/center-content-module'
import '../sections/section-two-column-embed'
import '../sections/section-delivery-table'
import '../sections/section-tabbed-comparison-table'
import '../sections/section-new-contact-grid'
import '../sections/section-new-icon-6-col'

load([
    `index-accordion`,
    `index-hero-slider`,
    `index-articles`,
    `index-articles-row`,
    `index-brands-showcase`,
    `index-buyers-guide`,
    `index-content-grid`,
    `index-content-image-grid`,
    `index-counter`,
    `index-download-tabs`,
    `index-hero-cta`,
    `feature-contact`,
    `index-finance-block`,
    `index-hero-category`,
    `index-hero-image`,
    `index-featured-products`,
    `index-icons-links`,
    `section-how-it-works`,
    `section-multi-column-modals`,
    `section-accordion-two-columns-v2`,
    `section-testimonial-v2`,
    `section-accordion-right`,
    `section-icon-carousel`,
    `section-icon-3-cols`,
    `section-three-card-blogs`,
    `section-two-col-complex`,
    `section-compare-table`,
    `section-custom-collection-list`,
    `section-table-with-text`,
    `custom-images`,
    `banner-with-text`,
    `content-with-tabs`,
    `section-custom-collection-list`,
    `section-custom-location`,
    `section-tax-disclaimer`,
    `section-internal-navigation-grid`,
    `section-headshots`,
    `section-border-content`,
    `section-business-location`,
    `contact-us-grid`,
    `section-custom-locations`,
    `section-icon-6-col`,
    `section-brands`,
    `section-border-content-module`,
    `section-quote-card`,
    `section-three-column`,
    `center-content-module`,
    `section-two-column-embed`,
    `section-tabbed-calculator`,
    `section-delivery-table`,
    `section-flexible-table-content`,
    `section-tabbed-comparison-table`,
    `section-leadership-cards`,
    `section-flexible-accordion-content`,
    `section-flexible-video`,
    `section-highlights`,
    `section-new-contact-grid`,
    `section-new-icon-6-col`,
])